import React, { useState, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";
import { ConfirmDialog } from "@activecollab/components";
import PropTypes from "prop-types";

export const TrashButton = React.forwardRef(({ onClick, confirmTitle }, ref) => {
  const { t } = useTranslation();
  const [showConfirm, setShowConfirm] = useState(false);

  const handleClick = useCallback(() => {
    setShowConfirm(true);
  }, []);

  const handleConfirm = useCallback(() => {
    if (typeof onClick === "function") {
      onClick();
    }
    setShowConfirm(false);
  }, [onClick]);

  const handleCancel = useCallback(() => {
    setShowConfirm(false);
  }, []);

  return (
    <>
      <a
        ref={ref}
        href="#"
        onClick={handleClick}
        className="ang_preview_option_trash"
      >
        {t("Move to Trash")}
      </a>
      <ConfirmDialog
        open={showConfirm}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        dialogTitle={
          <Trans confirmTitle={confirmTitle}>
            Move <q>{{ confirmTitle }}</q> to Trash?
          </Trans>
        }
        dialogContent={t(
          "The item will remain in Trash for 30 days. To remove it permanently, go to Trash and empty it."
        )}
        confirmBtnText={t("Move to Trash")}
      />
    </>
  );
});

TrashButton.propTypes = {
  confirmTitle: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

TrashButton.displayName = "TrashButton";
